import "@/App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import PhysicsCoasterGame from "@/game/PhysicsCoasterGame";

function App() {
  return (
    <div className="App">
      <HashRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/play" element={<PhysicsCoasterGame />} />
        </Routes>
      </HashRouter>
    </div>
  );
}

export default App;
